// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./FieldValidationRuleTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS Component */

.FieldValidationRule-module__Container__IlGmP {
    display: flex;
    gap: var(--ds-xs);
    align-items: center;
    padding: var(--ds-xs);
    color: var(--ds-field-validation-rule-dissatisfied-color);
}

.FieldValidationRule-module__Satisfied__MfbLU {
    color: var(--ds-field-validation-rule-satisfied-color);
}

.FieldValidationRule-module__IconContainer__Xy9Z4 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.FieldValidationRule-module__DotContainer__rXXkH {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--ds-m);
    height: var(--ds-m);
}

.FieldValidationRule-module__Dot__w8ls5 {
    display: flex;
    width: var(--ds-xs);
    height: var(--ds-xs);
    background-color: var(--ds-field-validation-rule-dissatisfied-color);
    border-radius: var(--ds-border-radius-circle);
}
/* stylelint-enable property-disallowed-list -- DS Component */
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `FieldValidationRule-module__Container__IlGmP`,
	"Satisfied": `FieldValidationRule-module__Satisfied__MfbLU`,
	"IconContainer": `FieldValidationRule-module__IconContainer__Xy9Z4`,
	"DotContainer": `FieldValidationRule-module__DotContainer__rXXkH`,
	"Dot": `FieldValidationRule-module__Dot__w8ls5`
};
export default ___CSS_LOADER_EXPORT___;
